import { Stack, Typography, useTheme } from "@mui/material";

interface AskHelenaErrorBannerProps {
  message: string;
}

/** Shared by a failed turn and a conversation that wouldn't load. */
export const AskHelenaErrorBanner = ({
  message,
}: AskHelenaErrorBannerProps) => {
  const theme = useTheme();

  return (
    <Stack
      role="alert"
      sx={{
        p: "10px 16px",
        borderRadius: "8px",
        border: `1px solid ${theme.palette.primitive.system.red[200]}`,
        backgroundColor: theme.palette.primitive.system.red[25],
      }}
    >
      <Typography
        variant="body-small"
        sx={{ color: theme.palette.primitive.system.red[800] }}
      >
        {message}
      </Typography>
    </Stack>
  );
};
